import { atom } from 'jotai'

const STORAGE_KEY = 'onboarding_panel_collapsed'
const DISMISSED_KEY = 'onboarding_panel_dismissed'

// Initialize values from localStorage
const getInitialHidden = () => {
  if (typeof window === 'undefined') return false
  return localStorage.getItem(DISMISSED_KEY) === 'true'
}

const getInitialCollapsed = () => {
  if (typeof window === 'undefined') return false
  return localStorage.getItem(STORAGE_KEY) === 'true'
}

/**
 * Base atoms - primitive writable atoms
 */
const onboardingPanelHiddenBaseAtom = atom<boolean>(getInitialHidden())
const onboardingPanelCollapsedBaseAtom = atom<boolean>(getInitialCollapsed())

/**
 * Writable atom to hide/show the onboarding panel
 * This is separate from API-level dismissal - this just hides the panel temporarily
 */
export const hideOnboardingPanelAtom = atom(
  (get) => get(onboardingPanelHiddenBaseAtom),
  (get, set, hidden: boolean) => {
    set(onboardingPanelHiddenBaseAtom, hidden)
    localStorage.setItem(DISMISSED_KEY, hidden ? 'true' : 'false')
  }
)

/**
 * Writable atom to collapse/expand the onboarding panel
 */
export const collapseOnboardingPanelAtom = atom(
  (get) => get(onboardingPanelCollapsedBaseAtom),
  (get, set, collapsed: boolean) => {
    set(onboardingPanelCollapsedBaseAtom, collapsed)
    localStorage.setItem(STORAGE_KEY, collapsed ? 'true' : 'false')
  }
)
